import React, { useEffect, useState } from "react";
import { Input, Button, List, message } from "antd";
import OpenAI from "openai";

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true, // Only use this for development/demo purposes
});

const RealEstateChat = () => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const tryOpenAI = async () => {
    const completion = await openai.chat.completions.create({
      model: "gpt-4o-mini",
      messages: [
        { role: "system", content: "You are a helpful assistant." },
        {
          role: "user",
          content: "Write a haiku about recursion in programming.",
        },
      ],
    });
    console.log(completion.choices[0].message.content);
  };

  const isRealEstateQuestion = (question) => {
    const realEstateKeywords = [
      "house",
      "property",
      "rent",
      "buy",
      "mortgage",
      "real estate",
      "apartment",
      "home",
      "land",
      "investment",
      "listing",
      "value",
      "price",
      "market",
      "neighborhood",
      "location",
      "agent",
      "broker",
      "realtor",
      "sale",
      "sold",
      "buying",
      "selling",
      "renting",
      "leasing",
      "foreclosure",
      "investment",
      "flip",
      "flipping",
      "renovation",
      "renovate",
      "remodel",
      "remodeling",
      "zipcode",
      "zoning",
    ];
    return realEstateKeywords.some((keyword) =>
      question.toLowerCase().includes(keyword)
    );
  };

  useEffect(() => {
    tryOpenAI();
  }, []);

  const handleSendMessage = async () => {
    if (!inputValue.trim()) return;

    const newMessage = { text: inputValue, sender: "user" };
    setMessages([...messages, newMessage]);
    setInputValue("");

    if (isRealEstateQuestion(inputValue)) {
      setIsLoading(true);
      try {
        const completion = await openai.chat.completions.create({
          model: "gpt-3.5-turbo",
          messages: [
            {
              role: "system",
              content:
                "You are a helpful assistant that answers real estate related questions.",
            },
            { role: "user", content: inputValue },
          ],
        });

        const botResponse = {
          text: completion.choices[0].message.content,
          sender: "User",
        };
        setMessages((prevMessages) => [...prevMessages, botResponse]);
      } catch (error) {
        console.error("Error fetching response from OpenAI:", error);
        if (error.response) {
          console.error(error.response.status, error.response.data);
          message.error(
            `API error: ${error.response.status} ${error.response.data.error.message}`
          );
        } else {
          message.error("Failed to get a response. Please try again later.");
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      const botResponse = {
        text: "I'm sorry, but I can only answer real estate related questions. Could you please ask something about properties, houses, or real estate?",
        sender: "Turaboy",
      };
      setMessages((prevMessages) => [...prevMessages, botResponse]);
    }
  };

  return (
    <div className="chat-container">
      <List
        className="message-list"
        itemLayout="horizontal"
        dataSource={messages}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={item.sender === "user" ? "You" : "Turaboy"}
              description={item.text}
            />
          </List.Item>
        )}
      />
      <div className="input-area">
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onPressEnter={handleSendMessage}
          placeholder="Ask a real estate question..."
          disabled={isLoading}
        />
        <Button onClick={handleSendMessage} loading={isLoading}>
          Send
        </Button>
      </div>
    </div>
  );
};

export default RealEstateChat;
